﻿import { capacity } from "./../objects/v1_3/product/capacity/capacity";

import { week } from "../objects/front_end/calendar/week";
import { week_day } from "../objects/front_end/calendar/week_day";

import { Date_Service } from "../../system/services/date_service";
import { Rest_API } from "../../system/services/rest_api";

import { capacity_capacity } from '../objects/v1_3/product/capacity/capacity_capacity';
import { product_search } from "../objects/v1_3/product/search/product_search";

import store from "../../../tms/booking_engine/store/index";

export class Capacity {

    Rest: Rest_API = new Rest_API();

    public Get_Agent_Band_App_Id(): string {
        return store.getters.get_Agent_Login?.agency.band_app_id ?? import.meta.env.VITE_APP_ID;
    }
    public async Get_Capacity(tour_id: string, year: number, month: number): Promise<capacity> {
        return await this.Rest.Get_Data<capacity>(import.meta.env.VITE_APP_URL + "/api/v1.3/" + this.Get_Agent_Band_App_Id() + "/products/" + tour_id + "/capacity/" + year + "/" + month).then(response => { return response.json(); });
    }
    public Get_Capacity_Week(tour_id: string, year: number, month: number, capacity_info: capacity, iso_currency_code: string, age_category: string): week[] {
        let Week_Output = [];
        let start_date: Date = new Date(year, month - 1, 1);

        let month_Index = start_date.getMonth();

        start_date.setDate(start_date.getDate() - (start_date.getDate() - 1));
        start_date = this.previous_monday(start_date);

        let Done: Boolean = false;
        let date: Date = start_date;
        let count = 0;

        while (!Done) {
            Week_Output.push(this.build_week(tour_id, new Date(date), month_Index, capacity_info, iso_currency_code, age_category));
            date.setDate(date.getDate() + 7);
            Done = count++ > 2 && month_Index !== date.getMonth();
            month_Index = date.getMonth();
        }

        return Week_Output;
    }
    public Get_Capacity_Search_Week(year: number, month: number, product_search: product_search, iso_currency_code: string, age_category: string): week[] {
        let Week_Output = [];
        let start_date: Date = new Date(year, month - 1, 1);

        let month_Index = start_date.getMonth();

        start_date.setDate(start_date.getDate() - (start_date.getDate() - 1));
        start_date = this.previous_monday(start_date);

        let Done: Boolean = false;
        let date: Date = start_date;
        let count = 0;

        while (!Done) {
            Week_Output.push(this.build_search_week(new Date(date), month_Index, product_search, iso_currency_code, age_category));
            date.setDate(date.getDate() + 7);
            Done = count++ > 2 && month_Index !== date.getMonth();
            month_Index = date.getMonth();
        }

        return Week_Output;
    }
    private build_search_week(date: Date, current_month: number, product_search: product_search, iso_currency_code: string, age_category: string): week {
        let Week_Output: week = new week();
        Week_Output.days = [];
        let date_service: Date_Service = new Date_Service();

        for (var i = 0; i < 7; i++) {

            var day: week_day = new week_day();
            day.name = date.getDate().toString();
            day.number = date.getDate();
            day.is_current_month = date.getMonth() === current_month;
            day.is_today = date_service.is_today(date);
            day.totalCapacity = 0;
            day.date = date_service.string_date(date);
            day.output_date = date_service.string_date_output(date);
            day.tour_id = [];

            Week_Output.days.push(this.Capacity_Search_Update(day, product_search, iso_currency_code, age_category));

            date.setDate(date.getDate() + 1);
        }

        return Week_Output;
    }
    private Capacity_Search_Update(day: week_day, product_search: product_search, iso_currency_code: string, age_category: string): week_day {
        let date_service: Date_Service = new Date_Service();        

        if (product_search != undefined) {
            if (product_search.products != null) {
                product_search.products.forEach(Product => {
                    Product.departures.forEach(Departure => {
                        if (date_service.compare_date(Departure.start_date_time) == date_service.compare_date(day.output_date)) {
                            day.totalCapacity = day.totalCapacity + 1;
                            day.tour_id.push(Product.tour_id);
                        }
                    });
                });
            }
        }

        return day;
    }
    private build_week(tour_id: string, date: Date, current_month: number, capacity_info: capacity, iso_currency_code: string, age_category: string): week {
        let Week_Output: week = new week();
        Week_Output.days = [];
        let date_service: Date_Service = new Date_Service();

        for (var i = 0; i < 7; i++) {

            var day: week_day = new week_day();
            day.name = date.getDate().toString();
            day.number = date.getDate();
            day.is_current_month = date.getMonth() === current_month;
            day.is_today = date_service.is_today(date);
            day.date = date_service.string_date(date);
            day.output_date = date_service.string_date_output(date);
            day.tour_id = [];

            Week_Output.days.push(this.Capacity_Update(tour_id, day, capacity_info, iso_currency_code, age_category));

            date.setDate(date.getDate() + 1);
        }

        return Week_Output;
    }
    private Get_Price(capacity: capacity_capacity, iso_currency_code: string, age_category: string): number {
        let Amount: number = 0;
        let excludeDorms = import.meta.env.VITE_EXCLUDE_DORM_FROM_MIN_PRICE === "true";
        let isMultiDay = this.Get_Duration_From_Dates(capacity.start_date_time, capacity.end_date_time) > 1;

        // Try twice: first excluding dorms, then including them if nothing found
        for (let attempt = 0; attempt < 2; attempt++) {
            capacity.product_currencies.forEach(currency => {
                if (currency.iso_currency_code == iso_currency_code) {
                    currency.amounts.forEach(amount => {
                        if(!excludeDorms || !amount.room_type?.toLowerCase().includes("dorm")) {
                            if(!excludeDorms || (isMultiDay ? (amount.room_type !== "" && amount.room_type != null) : true)) {
                                if (amount.age_category == age_category) {
                                    if(Amount == 0 || amount.amount < Amount)
                                        Amount = amount.amount;
                                }
                            }
                        }
                    });
                }
            });
            if (Amount > 0) break;  // price found, exit early
            excludeDorms = false;    // try again including dorms
        }
        return Amount;
    }
    private Capacity_Update(tour_id: string, day: week_day, capacity_info: capacity, iso_currency_code: string, age_category: string): week_day {
        let date_service: Date_Service = new Date_Service();

        if (capacity_info != undefined) {
            if (capacity_info.capacities != null) {
                capacity_info.capacities.forEach(Item => {
                    if (date_service.compare_date(Item.start_date_time) == date_service.compare_date(day.output_date)) {
                        if(import.meta.env.VITE_SEATS_LEFT_FROM_ROOMS == "true")
                        {
                            day.totalCapacity = this.Get_capacity_From_Rooms(Item); //Item.free_seats;
                        }
                        else
                        {
                            day.totalCapacity = Item.free_seats;
                        }
                        day.capacity_info = Item;
                        day.tour_id.push(Item.tour_id);
                        if (Item.tour_id == tour_id) {
                            day.fromPrice = this.Get_Price(Item, iso_currency_code, age_category);
                        }
                    }
                });
            }
        }

        return day;
    }
    private Get_capacity_From_Rooms(capacity: capacity_capacity): number {
        let Returncapacity = capacity.free_seats;

        if(this.Get_Duration_From_Dates(capacity.start_date_time, capacity.end_date_time) > 1)
        {
            capacity.capacity_rooms.forEach(room => {
                if(room.free_rooms != null && room.free_seats != null && room.room_type != null && room.room_type != "")
                {
                    Returncapacity += room.free_seats * room.free_rooms;
                }
            });
        }

        return Returncapacity;
    }
    private Get_Duration_From_Dates(start_date: string, end_date: string): number {
        let startDate = new Date(start_date);
        let endDate = new Date(end_date);
        let duration = Math.ceil((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
        return duration;
    }
    previous_monday(from_date: Date): Date {

        var mDifference = from_date.getDay() - 1;

        if (mDifference < 0) {
            mDifference += 7;
        }

        from_date.setDate(from_date.getDate() + (mDifference * -1));

        return from_date;
    }
}